import { Dispatch } from "@reduxjs/toolkit";
import { SidebarMenuItemType } from "../helpers/types";
import { apiDelete, apiGet, apiPost, apiPut } from "./generic.api";

export type CreateItemBody = {
  position: number;
  name: string;
  tab1Name: string;
  tab1Value: string;
  tab2Name: string;
  tab2Value: string;
};

export const getSidebarDataForUser = async (
  dispatch: Dispatch,
): Promise<SidebarMenuItemType[]> => {
  return (
    (
      await apiGet<{ sidebarItems: SidebarMenuItemType[] }>(
        dispatch,
        `api/sidebar`,
      )
    )?.sidebarItems || []
  );
};

export const changeSidebarPositions = async (
  dispatch: Dispatch,
  sidebarItems: SidebarMenuItemType[],
): Promise<SidebarMenuItemType[]> => {
  return (
    (
      await apiPost<{ data: any }, SidebarMenuItemType[]>(
        dispatch,
        `api/sidebar`,
        sidebarItems,
      )
    )?.data || []
  );
};

export const deleteSidebarItem = async (
  dispatch: Dispatch,
  sidebarItemID: number,
): Promise<SidebarMenuItemType[]> => {
  return (
    (
      await apiDelete<{ data: any }, number>(
        dispatch,
        `api/sidebar?sidebarItemID=${sidebarItemID}`,
      )
    )?.data || []
  );
};

export const createNewDiagnosis = async (
  dispatch: Dispatch,
  body: CreateItemBody,
): Promise<SidebarMenuItemType[]> => {
  return (
    await apiPut<
      { updatedSidebarItems: SidebarMenuItemType[] },
      CreateItemBody
    >(dispatch, `api/sidebar`, body)
  ).updatedSidebarItems;
};

export const changeSidebarItemName = async (
  dispatch: Dispatch,
  sidebarItemID: number,
  name: string,
): Promise<SidebarMenuItemType[]> => {
  return (
    (
      await apiPost<
        { updatedSidebarItems: any },
        { sidebarItemID: number; name: string }
      >(dispatch, `api/sidebar/name`, { sidebarItemID, name })
    )?.updatedSidebarItems || []
  );
};

export const changeSidebarItemDiagnosisText = async (
  dispatch: Dispatch,
  sidebarItemID: number,
  type: string,
  value: string,
): Promise<SidebarMenuItemType[]> => {
  return (
    (
      await apiPost<
        { updatedSidebarItems: any },
        { sidebarItemID: number; type: string; value: string }
      >(dispatch, `api/sidebar/diagnosisText`, { sidebarItemID, type, value })
    )?.updatedSidebarItems || []
  );
};

export const duplicateSidebarItem = async (
  dispatch: Dispatch,
  sidebarItemID: number,
  copyName: string,
): Promise<SidebarMenuItemType> => {
  return (
    (
      await apiPost<
        { result: SidebarMenuItemType },
        { sidebarItemID: number; copyName: string }
      >(dispatch, `api/sidebar/duplicate`, { sidebarItemID, copyName })
    )?.result || 0
  );
};
